module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_1_0@2x.3f9d3b0d.png";